/**
 * @uncola/auth-client - Shared authentication package
 * Framework-agnostic authentication client for micro-frontends
 */

// Export API client configuration (copied from working apiClient.js)
export { configureApiClient, makeAuthenticatedRequest } from './apiClient';

// Export AWS config
export * from './aws-cognito-config';

// Export core auth client (framework-agnostic)
export { createAuthClient } from './authClient';
